import React from "react";
import styles from "./LoginModule.module.scss";
import TextField from "../../components/TextField/TextField";
import Button from "../../components/Button/Button";
import { Form, FormikProvider, useFormik } from "formik";
import { Credentials, getPublicSettings } from "../../ApiService";
import { useNavigate } from "react-router-dom";
import { useQuery } from "react-query";

export type LoginModuleProps = {
  title: string;
  credentials: Credentials;
  onSubmit: (values: Credentials) => void;
};

const LoginModule: React.FC<LoginModuleProps> = ({
  title,
  credentials,
  onSubmit,
}) => {
  const navigate = useNavigate();
  const formik = useFormik({
    initialValues: credentials,
    onSubmit: (values) => onSubmit(values),
  });

  const { data: settings } = useQuery("settings", getPublicSettings);
  const { values, handleChange } = formik;

  const handleRegistration = () => {
    navigate("/registration");
  };

  return (
    <FormikProvider value={formik}>
      <Form>
        <div className={styles.baseContainer}>
          <div className={styles.title}>{title}</div>
          <div className={styles.fieldsContainer}>
            <TextField
              name="email"
              type="text"
              placeholder="Введите email"
              onChange={handleChange}
              value={values.email}
            />
            <TextField
              name="password"
              type="password"
              placeholder="Введите пароль"
              onChange={handleChange}
              value={values.password}
              autoComplete="password"
            />
          </div>
          <div className="flex flex-col items-center gap-4">
            <Button
              type="submit"
              title="Войти"
              size="large"
              style={{ width: "100%" }}
            />
            <div
              className="bodySemiboldFont text-purple-600 cursor-pointer"
              onClick={handleRegistration}
            >
              Регистрация
            </div>
            {settings?.showAdminLink && (
              <a
                className="bodySemiboldFont text-purple-600 cursor-pointer"
                href={settings.adminLink}
                target="_blank"
                rel="noreferrer"
              >
                Помощь
              </a>
            )}
          </div>
        </div>
      </Form>
    </FormikProvider>
  );
};

export default LoginModule;
